export default __webpack_public_path__ + "static/media/green-tick-v2.bbad2d8f.svg";